module.exports = __webpack_public_path__ + "static/media/lg-chart.6218cb2c.png";